import EventBusyIcon from "@mui/icons-material/EventBusy";
import { Typography } from "@mui/material";
import orderBy from "lodash/orderBy";

import { ProductDataCancellationPolicy, ProductDataCancellationPolicyPenaltyListNode } from "../../apiHooks/useProduct";
import { BulletedList } from "../../components/BulletedList";
import { LabeledSection } from "../../components/LabeledSection";
import { useNextTranslation } from "../../hooks";

export type ProductSectionCancellationPolicyProps = {
    cancellationPolicy: ProductDataCancellationPolicy;
};

export function ProductSectionCancellationPolicy({
    cancellationPolicy: {
        isCancellable,
        penaltyList: { nodes: penalties },
    },
}: ProductSectionCancellationPolicyProps) {
    const [t] = useNextTranslation("product");
    const cancellationPolicyLabel = t("description.cancellationPolicy");
    const title = t("label.cancellationPolicy");
    return (
        <LabeledSection title={title} Icon={EventBusyIcon}>
            {isCancellable ? (
                <Penalties penalties={penalties} />
            ) : (
                <Typography style={{ fontSize: "1em" }}>{cancellationPolicyLabel}</Typography>
            )}
        </LabeledSection>
    );
}

function Penalties({ penalties }: { penalties: ProductDataCancellationPolicyPenaltyListNode[] }) {
    return (
        <BulletedList>
            {orderBy(penalties, "ordinalPosition").map((penalty, idx) => (
                <li key={idx}>
                    <Typography style={{ fontSize: "1em" }}>{penalty.formattedText}</Typography>
                </li>
            ))}
        </BulletedList>
    );
}
